import type { FC } from 'react'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import Navigation from '@segment/templates/Navigation'

import GettingStarted from '@segment/templates/GettingStarted'

import DividerSection from '@segment/templates/DividerSection'

import Layout from '@segment/next-shared/layout'

import Hero from './components/Hero'
import PredictiveAudiences from './components/PredictiveAudiences'
import PredictiveAIModels from './components/PredictiveAIModels'
import Resources from './components/Resources'
import SingleTestimonial from './components/SingleTestimonial'
import TrustIn from './components/TrustIn'
import BoostCampaign from './components/BoostCampaign'
import DiscoverAndActivate from './components/DiscoverAndActivate'

import ogImage from './assets/OgImage.jpg'

const copy = {
  pageTitle: `CustomerAI Predictions | Twilio Segment`,
  pageDescription: `With CustomerAI Predictions, marketers can easily predict future customer behavior to deliver precisely personalized campaigns without needing to tap data science teams.`,
}

const CustomerAIPredictionsView: FC = () => {
  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout pageTitle={copy.pageTitle} pageDescription={copy.pageDescription} pageOG={ogImage}>
        <Navigation />
        <Hero />
        <main>
          <PredictiveAudiences />
          <DividerSection />
          <PredictiveAIModels />
          <DividerSection />
          <DiscoverAndActivate />
          <DividerSection />
          <BoostCampaign />
          <DividerSection />
          <TrustIn />
          <SingleTestimonial />
          <DividerSection />
          <Resources />
          <GettingStarted />
        </main>
      </Layout>
      <Footer />
    </AppearanceProvider>
  )
}

export default CustomerAIPredictionsView
